import React, {useState, useEffect, useRef} from 'react';
import {Grid, TextField, Link, InputAdornment, Tooltip} from '@material-ui/core';
import {Types} from "../index";
import API from "@beardeddevops/react.api"
import {LineChart} from "react-chartkick";
import 'chart.js'
import moment from "moment-timezone";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import {Modal, ModalBody} from "reactstrap";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";

const FeEstimates = (props) => {

	const [filterDate, setFilterDate] = useState(moment().isoWeekday(3).format('YYYY-MM-DD'))
	const [filterUsers, setFilterUsers] = useState([])
	const [showDate, setShowDate] = useState(false)
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);

	async function handleDateChange(name, date) {
		setFilterDate(moment(date).isoWeekday(3).format('YYYY-MM-DD'));
		setShowDate(false)
	}

	useEffect(() => {
		setLoading(true)
		fetchData().then((data) => formatData(data))
	}, [filterDate]);

	async function formatData(data) {
		setData(data)
		setLoading(false)
	}

	async function fetchData() {
		let model = new API.BuildClass(Types.Engineer_Stats._name, API.RequestType.READ);
		model.filter = {
			'filterDate': filterDate,
			'filterUsers': props.id ? [props.id] : filterUsers
		}
		return await model.submit(null, 'GET_ALL');
	}

	const columns =[
		{
			Header: "Engineer",
			accessor: "engineer_name",
		},
		{
			Header: "Work Orders This Week",
			accessor: "wos_count",
		},
		{
			Header: "Est. Days Worked",
			accessor: "est_days_worked",
		},
		{
			Header: "Est. Commission",
			accessor: "est_commission",
		},
	]

	const startOfWeek = moment(filterDate).startOf('week'); // Sunday by default
	const endOfWeek = moment(filterDate).endOf('week');

	const weekRange = `${startOfWeek.format('MMM D')} - ${endOfWeek.format('MMM D')}`;

	return (
		<div className={'form-group'}>
			<Modal
				isOpen={showDate}
				toggle={() => setShowDate(!showDate)}
				size={"sm"}
				backdrop={true}
				style={{display: "none"}}
			>
				<ModalBody>
					<Framework.Elements.Date
						label={"Custom Date"}
						value={filterDate}
						update={handleDateChange}
						open={showDate}
						clearable={false}
						cancelLabel={''}
					/>
				</ModalBody>
			</Modal>
			<div className={"row rbc-toolbar"}>
				<div>
					<IconButton onClick={async () => {
						setFilterDate(moment(filterDate).subtract(7, 'day').format('YYYY-MM-DD'))
					}}><LeftArrowIcon/></IconButton>
					<button className="rbc-today" type="button" onClick={async () => {
						setFilterDate(moment(Date.now()).isoWeekday(3).format('YYYY-MM-DD'))
					}}>This Week
					</button>
					<IconButton onClick={async () => {
						setFilterDate(moment(filterDate).add(7, 'day').format('YYYY-MM-DD'))
					}}><RightArrowIcon/></IconButton>
				</div>
				<div className={"rbc-toolbar-label"}>
					<label onClick={() => {
						setShowDate(true)
					}}>
						{weekRange}
					</label>
				</div>
				<button className="rbc-today" type="button" onClick={async () => {
					setLoading(true)
					fetchData().then((data) => formatData(data))
				}}>Refresh
				</button>
			</div>

			<ReactTable
				key={data}
				columns={columns}
				manual // Forces table not to paginate or sort automatically, so we can handle it server-side
				data={data}
				loading={loading} // Display the loading overlay when we need it
				loadingText="Requesting Data"
				onFetchData={fetchData} // Request new data when things change
				expanderDefaults={{
					sortable: true,
					resizable: true,
					filterable: true,
					width: undefined
				}}
				// defaultSorted={[
				// 	{
				// 		id: this.model.sort,
				// 		desc: this.model.order === 'desc'
				// 	}
				// ]}
				defaultPageSize={data.length}
				className="-striped -highlight"
				// onPageSizeChange={this.onPageSizeChange}
				pageSize={data.length}
			/>

		</div>
	);

};
export default FeEstimates;